import paths from "@ingka/icons-shared/paths/chevron-down-small";
import { renderPaths } from "../renderPaths.mjs";
var chevron_down_small_default = () => renderPaths(paths);
export {
  chevron_down_small_default as default
};
